import { styled, Tooltip, TooltipProps } from '@mui/material';
import palette from 'src/constants/palette';

export interface StyledTooltipProps extends TooltipProps {}

export const StyledTooltip = styled(Tooltip)({
    '& .MuiTooltip-arrow': {
        color: palette.tooltip,
    },
});

export default StyledTooltip;
